/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dept', {
            parent: 'board',
            url: '/board/{select}/dept?page&sort&search',
            data: {
                authorities: ['ROLE_FINANCE'],
                pageTitle: 'askApp.dept.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/dept/depts.html',
                    controller: 'BoardDeptController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        select: $stateParams.select
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dept');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('enumDeptStatus');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('member-management');
                    $translatePartialLoader.addPart('enumMemberStatus');
                    return $translate.refresh();
                }],
                entityProfile: ['$stateParams', 'MemberManagement', function($stateParams, MemberManagement) {
                    if($stateParams.select) {
                        return MemberManagement.get({id : $stateParams.select}).$promise;
                    }
                    return null;
                }]
            }
        })
        .state('board.dept.edit', {
            parent: 'board.dept',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entityProfile', function($stateParams, $state, $uibModal, entityProfile) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function(Dept) {
                            return Dept.get({id : $stateParams.id}).$promise;
                        }],
                        entityProfile: entityProfile,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dept', null, { reload: 'board.dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.dept.new', {
            parent: 'board.dept',
            url: '/new',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entityProfile', function($stateParams, $state, $uibModal, entityProfile) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('payment');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: function () {
                            return {
                                date: new Date(),
                                reference: null,
                                pointValue: 0,
                                amount: null,
                                comment: null,
                                category: "",
                                sepa: null,
                                paymentStatus: null,
                                id: null
                            };
                        },
                        entityProfile: entityProfile,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function() {
                    $state.go('board.dept', null, { reload: 'board.dept' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
